import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'
import { initMonitoring } from './lib/monitoring'
import { sentryProvider } from './lib/sentryProvider'
import { initPostHog } from './integrations/analytics/posthog'
import { initGTM } from './integrations/analytics/gtm'
import { setupAnalyticsBridge } from './integrations/analytics/analytics-bridge'
import { registerSessionContext } from './integrations/analytics/sessionContext'
import { captureAttribution } from './utils/attribution'

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
  });
  initMonitoring(sentryProvider);
}

// Before anything that can rewrite the query string, so an ad click is read
// from the URL the person actually landed on.
captureAttribution();

initPostHog();
registerSessionContext();
initGTM();
setupAnalyticsBridge();

createRoot(document.getElementById("root")!).render(<App />);
